import * as PromoVoucherActions from '../actions/promo-vouchers.actions';
import * as PromoVoucherState from '../states/promo-vouchers.state';
import * as _ from 'lodash';

export class State extends PromoVoucherState.State { }

const initialState: PromoVoucherState.State = PromoVoucherState.initialState;

/**
 *
 * @export
 * @param {*} [state=initialState]
 * @param {PromoVoucherActions.Actions} action
 * @returns {PromoVoucherState.State}
 */
export function reducer(state = initialState, action: PromoVoucherActions.Actions): PromoVoucherState.State {

	switch (action.type) {
		
		case PromoVoucherActions.ActionTypes.PUT_PROMO_VOUCHERS:
			state = Object.assign({}, state, { loading: false, promo_vouchers: Object.assign([], action.payload) });
			return state;

		case PromoVoucherActions.ActionTypes.RESET:
			state = Object.assign({}, state, { loading: true, promo_vouchers: null });
			return state;

		default:
			return state;
	}
}

export const getPromoVouchers = (state: PromoVoucherState.State) => { if (state.promo_vouchers) return state.promo_vouchers;
};
